import React, { useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { unlockActions } from '../../store/actions';
import styled from 'styled-components/macro';
import showPassword from '../../assets/images/ShowPassword.svg';
import hidePassword from '../../assets/images/HidePassword.svg';
import { unlockFileSelector } from '../../store/selectors';
import { Button, Dialog } from '@material-ui/core';
import { ReactComponent as UnlockIsLoading } from '../../assets/images/assign-loading.svg';
export interface InputPasswordOverlayProps {
  open: boolean;
  handleClose: () => void;
}
const name = 'InputPassword';
const propsFromDispatchSelector = (state) => state.showOverlay[name];

const InputPasswordOverlay: React.FC<InputPasswordOverlayProps> = ({
  open,
  handleClose,
}) => {
  const dispatch = useDispatch();
  const {
    unlockStatusMap,
    // error
  } = useSelector(unlockFileSelector);
  const propsFromDispatch = useSelector(propsFromDispatchSelector);
  const { ticketId, file = {} } = propsFromDispatch || {};

  const [isShow, setIsShow] = useState(false);
  const [password, setPassword] = useState('');
  const handleShowPassword = () => {
    setIsShow(!isShow);
  };
  const handleUnlock = () => {
    dispatch(
      unlockActions.unlockFile(ticketId, file.partId, password),
    );
  };

  const unlockStatus = useMemo(
    () => unlockStatusMap[file.partId] || 'OPEN',
    [unlockStatusMap, file],
  );

  const isLoading = useMemo(() => unlockStatus === 'REQUESTING', [
    unlockStatus,
  ]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <SInputPasswordOverlay>
        <STitle>Password</STitle>
        {isLoading ? (
          <SUnlockIsLoading />
        ) : (
          <SSubtitle
            className={unlockStatus === 'LOCKED' ? 'incorrect' : ''}
          >
            {unlockStatus === 'LOCKED'
              ? 'Password is incorrect'
              : 'Please enter password to access file'}
          </SSubtitle>
        )}

        <SInputBox>
          <SInput
            autoFocus
            placeholder="Input Password"
            type={!isShow ? `password` : ``}
            onChange={(event) => setPassword(event.target.value)}
          />
          <SPasswordIcon
            className="clickable"
            src={isShow ? showPassword : hidePassword}
            onClick={() => handleShowPassword()}
          />
        </SInputBox>
        <SButton>
          <Button
            color="default"
            variant="outlined"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => handleUnlock()}
          >
            Submit
          </Button>
        </SButton>
      </SInputPasswordOverlay>
    </Dialog>
  );
};

export default InputPasswordOverlay;

const SUnlockIsLoading = styled(UnlockIsLoading)`
  height: 23px;
`;
const SButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  align-items: center;
  & > .MuiButton-root + .MuiButton-root {
    margin-left: 0.5rem;
  }
`;
const SInputBox = styled.div`
  background: ${(props) => props.theme.palette.common.white};
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.17);
  border-radius: 7px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  padding: 0px 5px 0px 5px;
  position: relative;
`;
const SPasswordIcon = styled.img`
  position: absolute;
  top: 0.3rem;
  right: 0.5rem;
  height: 20px;
  margin-top: 3px;
`;
const SInput = styled.input`
  border: none;
  line-height: 2rem;
  width: 100%;
  &:focus {
    outline: none;
  }
`;
const STitle = styled.div`
  font-weight: bold;
  font-size: ${(props) => props.theme.typography.fontSize.big};
  line-height: ${(props) => props.theme.typography.lineHeight.title};
`;
const SSubtitle = styled.div`
  font-style: italic;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  margin-top: 5px;
  &.incorrect {
    color: ${(props) => props.theme.palette.error.main};
  }
`;
const SInputPasswordOverlay = styled.div`
  width: 400px;
  height: 180px;
  padding: 30px;
  display: grid;
  text-align: center;
`;
